module.exports = __webpack_public_path__ + "static/media/Heather Greatbatch.bf09cd12.JPG";